let ol = require('openlayers');
let jsts = require('jsts/dist/jsts');
let parser = new jsts.io.OL3Parser(undefined, ol);

let AbstractOperation = require('../operations/abstract');
let IsWithinResult = require('../operations/types/isWithinResult');


/**
 * Класс IsWithin
 * @extends AbstractOperation
 */
class IsWithin extends AbstractOperation {

    /**
     * Создает экземпляр класса IsWithin
     */
  constructor() {
    super()
  }


    /**
     *
     * @param featureA
     * @param featureB
     * @return {boolean}
     */
    execute(featureA, featureB) {
        let isWithin = operation(featureA, featureB);
        return new IsWithinResult({
            result: isWithin
        })
    }
    }

function operation(featureA, featureB) {
    let geomA = parser.read(featureA.getGeometry());
    let geomB = parser.read(featureB.getGeometry());
    let result = geomA.within(geomB);
    return result
}



module.exports = IsWithin;